onInteractive(function () {
	// De oude site toonde bij elk bezoek willekeurig een van de drie logovarianten met een andere houding van de man.
	var logo = document.querySelector('.navbar-band .logo');
	if (logo) {
		var variant = Math.ceil(Math.random() * 3);
		logo.src = logo.getAttribute('src').replace(/logo-0\d\.png/, 'logo-0' + variant + '.png');
	}

	// Elke link naar #offerteaanvraag (knoppen "Nu aanvragen" in de inhoud) klapt het offertepaneel onder het menu open.
	var panel = document.getElementById('offerteaanvraag');
	if (!panel) {
		return;
	}
	document.addEventListener('click', function (event) {
		var link = event.target.closest('a[href$="#offerteaanvraag"]');
		if (!link) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		panel.classList.add('show');
		panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
	});
	if (window.location.hash === '#offerteaanvraag') {
		panel.classList.add('show');
	}
});
